import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { MobileNav } from '../components/MobileNav';
export function SelfDecodeHome() {
  return <>
      <Helmet data-id="element-4363">
        <title data-id="element-4364">Self Decode | Lazy Monk Labs</title>
        <meta name="description" content="See yourself clearly — without fixing, judging, or improving. One honest reflection." data-id="element-4365" />
      </Helmet>

      <div className="min-h-screen bg-[#0A0A0A] text-[#F5F5F5]" data-id="element-4366">
        <MobileNav data-id="element-4367" />

        <main className="pt-20 sm:pt-24 pb-16 sm:pb-20" data-id="element-4368">
          <div className="max-w-2xl mx-auto px-6 sm:px-8" data-id="element-4369">
            {/* ABOVE THE FOLD */}
            <section className="min-h-[60vh] flex flex-col justify-center py-16 sm:py-20" data-id="element-4370">
              <div className="space-y-8 sm:space-y-10" data-id="element-4371">
                {/* Primary Line */}
                <h1 className="text-2xl sm:text-3xl md:text-4xl leading-relaxed text-[#F5F5F5]" style={{
                fontFamily: 'Georgia, serif'
              }} data-id="element-4372">
                  See yourself clearly — without fixing, judging, or improving.
                </h1>

                {/* Subline */}
                <p className="text-base sm:text-lg text-gray-500 leading-relaxed" data-id="element-4373">
                  One honest reflection. No signup. Nothing to optimize.
                </p>

                {/* Primary CTA */}
                <div className="pt-4 sm:pt-6" data-id="element-4374">
                  <Link to="/decode/entry" className="inline-block px-8 sm:px-10 py-4 sm:py-5 bg-[#F5F5F5] text-[#0A0A0A] text-sm font-medium uppercase tracking-widest hover:bg-gray-200 transition-colors" data-id="element-4375">
                    Start Self Decode
                  </Link>
                  <p className="text-xs text-gray-600 mt-4" data-id="element-4376">
                    Takes about 2 minutes
                  </p>
                </div>
              </div>
            </section>

            {/* SAFETY SIGNAL */}
            <section className="py-12 sm:py-16 border-t border-[#2B2B2B]" data-id="element-4377">
              <div className="space-y-4 text-sm text-gray-500 leading-relaxed" data-id="element-4378">
                <p data-id="element-4379">You won't be told what to do.</p>
                <p data-id="element-4380">Nothing here says you're broken.</p>
                <p data-id="element-4381">You can stop at any point.</p>
              </div>
            </section>

            {/* CONTRAST BLOCK */}
            <section className="py-12 sm:py-16 border-t border-[#2B2B2B]" data-id="element-4382">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-12 sm:gap-16" data-id="element-4383">
                {/* WHAT THIS IS */}
                <div className="space-y-6" data-id="element-4384">
                  <p className="text-xs font-mono text-gray-600 uppercase tracking-wider" data-id="element-4385">
                    What this is
                  </p>
                  <div className="space-y-3 text-sm text-gray-400 leading-relaxed" data-id="element-4386">
                    <p data-id="element-4387">A reflection of your current patterns</p>
                    <p data-id="element-4388">Language for something you already feel</p>
                    <p data-id="element-4389">A pause before reaction</p>
                  </div>
                </div>

                {/* WHAT THIS IS NOT */}
                <div className="space-y-6" data-id="element-4390">
                  <p className="text-xs font-mono text-gray-600 uppercase tracking-wider" data-id="element-4391">
                    What this is not
                  </p>
                  <div className="space-y-3 text-sm text-gray-400 leading-relaxed" data-id="element-4392">
                    <p data-id="element-4393">Therapy</p>
                    <p data-id="element-4394">Coaching</p>
                    <p data-id="element-4395">Productivity advice</p>
                    <p data-id="element-4396">A personality test</p>
                  </div>
                </div>
              </div>
            </section>

            {/* SOCIAL PROOF */}
            <section className="py-12 sm:py-16 border-t border-[#2B2B2B]" data-id="element-4397">
              <p className="text-sm text-gray-600 leading-relaxed" data-id="element-4398">
                Shared by people who didn't know how to explain what they were
                experiencing.
              </p>
            </section>

            {/* SECONDARY CTA */}
            <section className="py-12 sm:py-16 border-t border-[#2B2B2B]" data-id="element-4399">
              <Link to="/decode/entry" className="inline-block px-8 sm:px-10 py-4 sm:py-5 bg-[#F5F5F5] text-[#0A0A0A] text-sm font-medium uppercase tracking-widest hover:bg-gray-200 transition-colors" data-id="element-4400">
                Start Self Decode
              </Link>
              <p className="text-xs text-gray-600 mt-4" data-id="element-4401">No account required.</p>
            </section>
          </div>
        </main>

        {/* Minimal Footer */}
        <footer className="py-8 sm:py-12 px-6 border-t border-[#2B2B2B]" data-id="element-4402">
          <div className="max-w-2xl mx-auto" data-id="element-4403">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-4404">
              <Link to="/" className="text-xs text-gray-600 hover:text-gray-400 transition-colors" data-id="element-4405">
                Lazy Monk Labs
              </Link>
              <p className="text-xs text-gray-700" data-id="element-4406">
                © {new Date().getFullYear()}
              </p>
            </div>
          </div>
        </footer>
      </div>
    </>;
}